import { useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ThreeBand } from "../components/macaron/ThreeBand";
import "../services.css";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (d) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: d } }),
};

export default function GetToKnowUsPage() {
  const { openContact } = useOutletContext();
  return (
    <section className="gtku-section" data-testid="about-page">
      <div className="mac-container" style={{ position: "relative", zIndex: 1, width: "100%", textAlign: "center" }}>
        <div className="cta-glow" />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 880, margin: "0 auto" }}>
          <motion.div variants={fadeUp} custom={0} initial="hidden" animate="show">
            <span className="gtku-pill" data-testid="coming-soon-pill">
              <span className="gtku-pill-dot" />
              <span className="gtku-pill-text">FULL STORY · COMING SOON</span>
            </span>
          </motion.div>

          <motion.div variants={fadeUp} custom={0.1} initial="hidden" animate="show">
            <div className="mac-eyebrow-row center" style={{ marginTop: 30 }}>
              <ThreeBand />
              <p className="mac-eyebrow">GET TO KNOW US</p>
            </div>
          </motion.div>

          <motion.h1
            variants={fadeUp}
            custom={0.1}
            initial="hidden"
            animate="show"
            className="gtku-h"
            data-testid="about-headline"
            style={{ marginTop: 26 }}
          >
            The people behind<br />
            <span className="mac-gradient-text gtku-brand">The Macaron AI.</span>
          </motion.h1>

          <motion.p
            variants={fadeUp}
            custom={0.3}
            initial="hidden"
            animate="show"
            className="gtku-story-center"
            data-testid="about-story"
          >
            <span style={{ color: "var(--cream)", fontWeight: 600 }}>
              Founder-led and built by visual merchandising experts.
            </span>{" "}
            After more than a decade inside the world's leading beauty and luxury brands, we built the platform we
            wished we'd had, one that protects brand vision from strategy to shelf. Our full story, team, and
            philosophy are on the way. In the meantime, we'd love to introduce ourselves directly, in person or
            virtually.
          </motion.p>

          <motion.div
            variants={fadeUp}
            custom={0.5}
            initial="hidden"
            animate="show"
            style={{ marginTop: 42, display: "flex", flexDirection: "column", alignItems: "center", gap: 18 }}
          >
            <button
              className="mac-btn gtku-cta"
              data-testid="book-call-btn"
              onClick={openContact}
              style={{ padding: "16px 32px", letterSpacing: "0.2em" }}
            >
              Book a Call With Our Founder <ArrowRight size={15} strokeWidth={2.5} />
            </button>
            <span className="gtku-meta">30 MINUTES · IN PERSON OR VIRTUAL</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
